<script setup lang="ts">

import Cashback from '@presentation/Icons/Cashback.vue';
import Concierge from '@presentation/Icons/Concierge.vue';
import Tyres from '@presentation/Icons/Tyres.vue';
import WindscreenRepair from '@presentation/Icons/WindscreenRepair.vue';
import HealthAssessments from '@presentation/Icons/HealthAssessments.vue';
import HealthMonitoring from '@presentation/Icons/HealthMonitoring.vue';

</script>

<template>
    <div class="flex flex-wrap gap-y-6 2xl:gap-y-10">
            
        <!-- <div class="flex flex-col items-center basis-1/2 text-center py-2 px-4">
            <Tyres class="w-10 2xl:w-14" />
            <h1 class="font-bold 2xl:my-1 text-sm md:text-base 2xl:text-lg 3xl:text-2xl"><span class="text-emerald-500">FREE</span> Tyre Puncture Repair</h1>
            <h2 class="text-white/60 text-xs md:text-sm 2xl:text-base 3xl:text-lg">
                Get punctures repaired at no cost, keeping you safe on the road.
            </h2>
        </div>
  
        <div class="flex flex-col items-center basis-1/2 text-center py-2 px-4">
            <WindscreenRepair class="w-10 2xl:w-14 -top-1" />
            <h1 class="font-bold 2xl:my-1 text-sm md:text-base 2xl:text-lg 3xl:text-2xl"><span class="text-emerald-500">FREE</span> Windscreen Repair</h1>
            <h2 class="text-white/60 text-xs md:text-sm 2xl:text-base 3xl:text-lg">
                Repair chips ensuring your windshield stays roadworthy.
            </h2>
        </div> -->

        <div class="flex flex-col items-center basis-1/2 text-center py-2 px-4">
            <HealthAssessments class="w-10 2xl:w-14 text-[#B5424A]"/>
            <h1 class="font-bold 2xl:my-1 text-sm md:text-base 2xl:text-lg 3xl:text-2xl"><span class="text-emerald-500">FREE</span> Health Assessments</h1>
            <h2 class="text-white/60 text-xs md:text-sm 2xl:text-base 3xl:text-lg">
                Get complimentary health checks for your vehicle to identify any issues early.
            </h2>
        </div>

        <div class="flex flex-col items-center basis-1/2 text-center py-2 px-4">
            <Concierge class="w-10 2xl:w-14 -mt-3 text-[#B5424A]" />
            <h1 class="font-bold 2xl:my-1 text-sm md:text-base 2xl:text-lg 3xl:text-2xl">Dedicated Concierge</h1>
            <h2 class="text-white/60 text-xs md:text-sm 2xl:text-base 3xl:text-lg">
                Enjoy personalised assistance whenever you need it.
            </h2>
        </div>

        <div class="flex flex-col items-center basis-1/2 text-center py-2 px-4">
            <HealthMonitoring class="w-10 2xl:w-14 text-[#B5424A]"/>
            <h1 class="font-bold 2xl:my-1 text-sm md:text-base 2xl:text-lg 3xl:text-2xl">24/7 Health Monitoring</h1>
            <h2 class="text-white/60 text-xs md:text-sm 2xl:text-base 3xl:text-lg">
                Ensure continuous tracking of your 
                vehicle's health and performance
            </h2>
        </div>

        <div class="flex flex-col items-center basis-1/2 text-center py-2 px-4">
            <Cashback class="w-10 2xl:w-14 mt-6 text-[#B5424A]" />
            <h1 class="font-bold 2xl:my-1 text-sm md:text-base 2xl:text-lg 3xl:text-2xl">Carbucks Rewards Program</h1>
            <h2 class="text-white/60 text-xs md:text-sm 2xl:text-base 3xl:text-lg">
                Earn real cash rewards and discounts for using our services and making purchases.
            </h2>
        </div>

    </div>

</template>